import React, { createContext, useState, useEffect } from "react";
import { IoMdNotifications } from "react-icons/io"

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toastMessage, setToastMessage] = useState(null);
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    if (toastMessage && !timerId) {
      const id = setTimeout(() => {
        setToastMessage(null);
        setTimerId(null);
      }, 5000);

      setTimerId(id);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [toastMessage, timerId]);

  return (
    <ToastContext.Provider value={{ toastMessage, setToastMessage }}>
      {children}
      {toastMessage && (
        <div className="toast-container">
          <div
            id="toast-interactive"
            className="w-full max-w-md p-4 text-gray-500 bg-white rounded-lg border border-[#003464] shadow dark:bg-gray-800 dark:text-gray-400"
            role="alert"
          >
            <div className="flex">
              <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-blue-500 bg-[#003464] rounded-lg dark:text-blue-300 dark:bg-blue-900">
                <IoMdNotifications size={20} color={"white"}/>
              </div>
              <div className="ml-3 text-sm font-normal">
                <span className="mb-1 text-md font-bold text-gray-900 dark:text-white">
                  Notication
                </span>
                <div className="mb-2 text-md font-semibold">
                  {toastMessage}
                </div>
              </div>
              <button
                type="button"
                className="ml-auto -mx-1.5 -my-1.5 bg-white items-center justify-center flex-shrink-0 text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700"
                data-dismiss-target="#toast-interactive"
                aria-label="Close"
                onClick={() => setToastMessage(null)}
              >
                <span className="sr-only">Close</span>
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </ToastContext.Provider>
  );
};
